module.exports = __webpack_public_path__ + "static/media/igthree.09f13edc.webp";